// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ILatencyBand {
	lowMs: number;

	highMs: number | undefined;

	$type?: string | undefined;
}
export class LatencyBand {
	constructor(data?: ILatencyBand) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	lowMs: number = 0;

	highMs: number | undefined;

	static $type: string = "CoreApi.Models.ClientEndpoints.LatencyBand, ";
	$type?: string | undefined = LatencyBand.$type;
}

